import { FontProps } from '../font-props-interface';
import './font-plan-body-5-white.scss';

const FontPlanBody5White: React.FC<FontProps> = ({ children }): JSX.Element => (
    <span className="font-body-5-white">{children}</span>
);

export default FontPlanBody5White;
